import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App.tsx';
import WarningBanner from './components/WarningBanner.tsx';

// A chave do acompanhamento da entrega ao vivo vai no caminho das consultas
// do mapa (/live-deliveries/share/<chave>) e do mapa embutido (/mapa/<chave>):
// sai de tudo que vai pro Sentry (erro, desempenho, breadcrumb e gravação de
// sessão), como no dashboard. A chave abre a posição do motorista.
const CHAVE_NA_URL = /\/(share|mapa)\/[^/?#"\\\s]+/gi;
const semChave = <T,>(dado: T): T => {
  if (dado == null) return dado;
  try {
    return JSON.parse(JSON.stringify(dado).replace(CHAVE_NA_URL, '/$1/[chave]'));
  } catch {
    return dado;
  }
};

const NA_ROTA_DO_MAPA = /^\/mapa(\/|$)/.test(window.location.pathname);

// Initialize Sentry only in production
if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://5514719003c84ada5f2ededf0cf6916e@o4507351375085568.ingest.us.sentry.io/4508649129181184',
    integrations: [
      Sentry.browserTracingIntegration(),
      // No mapa embutido (/mapa e /mapa/<chave>) a gravação de sessão nem
      // liga: o endereço inicial da página vai no meta da gravação, por onde
      // os filtros abaixo não passam (mesma escolha do dashboard nas rotas
      // com token).
      ...(NA_ROTA_DO_MAPA ? [] : [Sentry.replayIntegration({ beforeAddRecordingEvent: (evento) => semChave(evento) })]),
    ],
    beforeSend: (evento) => semChave(evento),
    beforeSendTransaction: (evento) => semChave(evento),
    beforeBreadcrumb: (b) => semChave(b),
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Aviso de golpe no topo, logo abaixo da barra (antes ficava dentro do
        quadro do rastreio e empurrava o mapa ao vivo pra baixo). Fora do
        mapa embutido (/mapa/…), que é só o mapa dentro de outro sistema. */}
    {!NA_ROTA_DO_MAPA && <WarningBanner />}
    <App />
  </StrictMode>
);
